export default {
    loggedIn(state) {
        return state.loggedIn;
    },
    loggedInUser ({loggedInUser}) {
        return loggedInUser;
    },
}
